'use strict';
self.addEventListener('push', function (event) {
    event.waitUntil(
        self.registration.pushManager.getSubscription().then(function (subscription) {
            var e = {};
            e = event.data ? event.data.text() : "{}";
            e = JSON.parse(e);
            var title = e.notification.title;
            var body = e.notification.body;
            var icon = e.notification.icon;
            var badge = e.notification.badge;
            var image = e.notification.image;
            var url = e.notification.url;
            var click_action = e.notification.click_action;
             var fhMessageId = e.data.fhMessageId;

            return self.registration.showNotification(title, {
                body: body,
                icon: icon,
                badge: badge,
                image: image,
                data: {
                    url: click_action,
                    fhMessageId : fhMessageId
                }
            });

        })
    );
});


self.addEventListener('notificationclick', function (event) {
    var fhMessageId = event.notification.data.fhMessageId;
    var url = "https://v25.firsthive.com/engage/webpush/trackNotification";
    var regId = '';
    url = url + '?messageId=' + fhMessageId;
    fetch(url).then(function (response) {
        // Examine the text in the response  
        console.log('response = '+ response);
    }).catch(function (err) {
        console.log('Unable to retrieve data', err);
    })

    event.notification.close();

    event.waitUntil(
        clients.matchAll({
            type: "window"
        })
        .then(function (clientList) {
            for (var i = 0; i < clientList.length; i++) {
                var client = clientList[i];
                if (client.url == '/' && 'focus' in client)
                    return client.focus();
            }
            if (clients.openWindow) {
                return clients.openWindow(event.notification.data.url);
            }
        })
    );
});


